import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { setErrorHandler } from "../services/api";

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast debe usarse dentro de ToastProvider");
  }
  return context;
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = "error", duration = 5000) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);

    if (duration > 0) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
      }, duration);
    }

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const showError = useCallback(
    (message) => addToast(message, "error"),
    [addToast]
  );

  const showSuccess = useCallback(
    (message) => addToast(message, "success"),
    [addToast]
  );

  const showWarning = useCallback(
    (message) => addToast(message, "warning"),
    [addToast]
  );

  // Registrar el handler de errores en la API
  useEffect(() => {
    setErrorHandler(showError);
    return () => setErrorHandler(null);
  }, [showError]);

  return (
    <ToastContext.Provider
      value={{ toasts, addToast, removeToast, showError, showSuccess, showWarning }}
    >
      {children}
    </ToastContext.Provider>
  );
}

export { ToastContext };
